/**
 * WorkBar — card shell rendered above the composer that consolidates the git
 * action row and the agents/team row into a single unified surface.
 *
 * Rows are separated by a 1px hairline divider; the outer border is continuous
 * so the whole card reads as one object.
 */
import type { ReactNode } from "react";

import { cn } from "~/lib/utils";

interface WorkBarProps {
  readonly children: ReactNode;
  readonly className?: string;
}

export function WorkBar({ children, className }: WorkBarProps) {
  return (
    <div
      data-testid="workbar"
      className={cn(
        "@container/workbar flex flex-col divide-y divide-border/60 rounded-lg border border-border/60 bg-card/60",
        className,
      )}
    >
      {children}
    </div>
  );
}
